import { Auth0Provider as BaseAuth0Provider } from "@auth0/auth0-react";
import { getAuth0Config } from "@dmtrigger/shared";

interface Auth0ProviderProps {
  children: React.ReactNode;
}

export function Auth0Provider({ children }: Auth0ProviderProps) {
  const auth0Config = getAuth0Config();

  return (
    <BaseAuth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      authorizationParams={{
        redirect_uri: auth0Config.redirectUri,
        audience: auth0Config.audience,
        scope: auth0Config.scope,
      }}
    >
      {children}
    </BaseAuth0Provider>
  );
}
